import styled, { css, keyframes } from 'styled-components'
import { getRgbaValue } from '../../../utils/styling'
import { Box } from '../../../shared_components/UI/Box'
import { MaxWidth } from '../../../shared_components/Page/styles'

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 14px;
  position: relative;
  overflow: hidden;
  .psuedo-right-border {
    background: ${({ theme }) => theme.colors.vaultBgSolid};
    z-index: 3;
    position: absolute;
    top: 0;
    left: 6px;
    height: 14px;
    border-radius: 35px;
    transition: width 0.2s;
  }
  .psuedo-right-border.second {
    background: ${({ theme }) => theme.colors.vaultBgSolid};
    z-index: 1;
    position: absolute;
    top: 0;
    left: 6px;
    height: 14px;
    border-radius: 35px;
    transition: width 0.2s;
  }
  .second-track {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 14px;
    border-radius: 35px;
    background: #2d3337;
    z-index: 2;
  }
`

export const Track = styled.div`
  border-radius: 35px;
  background: #2d3337;
  width: 100%;
  height: 14px;
`

export const Progress = styled.div<{ progress: number; isRight?: boolean }>`
  height: 14px;
  position: absolute;
  background: ${({ theme }) => theme.colors.brandPrimary};
  width: ${({ progress }) => progress}%;
  transition: width 0.2s;
  top: 0;
  border-radius: 35px;
  z-index: 4;
  ${({ isRight }) =>
    isRight &&
    css`
      right: 0;
      border-radius: 0px 35px 35px 0px;
      background: #fff;
      z-index: 0;
    `}
`

export const CORNER_CHUNK_SIZE = 24

export const createClipPathByChunkSize = (
  chunkSize = CORNER_CHUNK_SIZE,
  bottomRightOnly = false,
) => {
  return css`
    clip-path: polygon(
      ${bottomRightOnly ? 0 : chunkSize}px 0,
      100% 0,
      100% calc(100% - ${chunkSize}px),
      calc(100% - ${chunkSize}px) 100%,
      0 100%,
      0 ${chunkSize}px
    );
  `
}

export const clipPathForLevelBox = createClipPathByChunkSize()
export const clipPathForRefCodeBox = createClipPathByChunkSize(16)

export const LevelBox = styled(Box)`
  width: 650px;
  height: 100%;
  min-height: 360px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  padding: 1.5rem 2rem;
  z-index: 1000;
  flex-direction: column;
  background: ${getRgbaValue('#353a40', 0.7)};
  justify-content: space-between;
  ${clipPathForLevelBox}
  &::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colors.vaultBgSolid};
    z-index: -1;
    ${clipPathForLevelBox}
    top: 1.5px;
    left: 1.5px;
    border-radius: 4px;
    right: 1.5px;
    bottom: 1.5px;
  }
  span.current-level {
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
  }
  span.next-level {
    font-size: 32px;
    padding-bottom: 6px; // this is  to adjust for line height, could fiddle with values but YOLO
    font-style: normal;
    font-weight: 700;
    line-height: 1;
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    min-height: auto;
    gap: 28px;

    span.current-level {
      font-size: 38px;
    }
    span.next-level {
      font-size: 24px;
    }
  }
`

export const RefCodeBox = styled(LevelBox)`
  ${clipPathForRefCodeBox}
  width: 100%;
  height: 96px;
  min-height: 96px;
  padding: 30px 32px;
  overflow: visible;
  border: none;
  border-radius: 0;
  background: repeating-linear-gradient(
      0deg,
      transparent,
      transparent 1px,
      yellow 4px,
      yellow 5px /* Adjust the spacing of the yellow dots */
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 2px,
      yellow 3px,
      yellow 5px /* Adjust the spacing of the yellow dots */
    );
  :after {
    left: 0.75px;
    top: 0.75px;
    width: calc(100% - 1.5px);
    height: calc(100% - 1.5px);
    border-radius: 0;
    ${clipPathForRefCodeBox}
    background: #0E1920;
  }
  transition: all 0.3s ease-in-out;
  :hover {
    cursor: pointer;
    filter: brightness(1.5);
  }
  span.code {
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
  }
  img.copy-icon {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 32px;
  }

  @media screen and (max-width: 768px) {
    height: 56px;
    min-height: 56px;
    padding: 10px 16px;
    span.code {
      font-size: 24px;
    }
  }
`

export const SecondSection = styled(Box)``

export const Hero = styled.div`
  min-height: 570px;
  width: 100%;
  background: url('/hero-cover-vault-dashboard.png') no-repeat center center;
  background-size: cover;
  z-index: 10;
  position: relative;
  padding: 4rem 0;
  padding-top: 8rem;
  h1 {
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 104.167% */
    letter-spacing: -0.48px;
  }
  span.lead {
    max-width: 655px;
    font-variant-numeric: ordinal;
    font-feature-settings: 'dlig' on, 'ss01' on, 'dnom' on;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 140% */
    letter-spacing: -0.8px;
  }
  ${MaxWidth} {
    z-index: 10;
    position: relative;
  }
  .loading-container {
    min-height: 300px;
  }
`

export const Container = styled(Box)<{ headerHeight: number }>`
  flex-direction: column;
  z-index: 10;
  min-height: 400px;
  span.small-cap {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 137.5% */
    letter-spacing: 4.8px;
    text-transform: uppercase;
  }
  span.yellow {
    color: ${({ theme }) => theme.colors.brandPrimary};
  }

  @media screen and (max-width: 768px) {
    span.small-cap {
      font-size: 12px;
      letter-spacing: 3.6px;
    }
  }
`

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;

  }
`

export const TYPEWRITER_DELAY = 0.005
export const TYPEWRITER_DURATION = 0.05

export const AnimatedChar = styled.span<{ delay: number }>`
  display: inline-block;
  opacity: 0;
  animation: ${fadeIn} ${TYPEWRITER_DURATION}s forwards;
  animation-delay: ${({ delay }) => `${delay}s`};
`

export const VaultPurchasedContainer = styled(Box)`
  h4 {
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 104.167% */
    letter-spacing: -0.48px;
  }

  @media screen and (max-width: 1000px) {
    flex: 1;
    width: 100%;
  }
`

export const VaultsPurchasedBox = styled(LevelBox)`
  width: 241px;
  height: 115px;
  min-height: 115px;
  padding: 24px 16px 24px;
  span.amount {
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  :after {
    background: #040f17;
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`

export const VaultInfoContainer = styled(Box)`
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const bottomRightOnlyClipPath = createClipPathByChunkSize(24, true)

export const MultipliersContainer = styled(LevelBox)`
  max-width: 650px;
  width: 100%;
  height: 160px;
  min-height: 160px;
  max-height: 160px;
  padding: 0rem 1rem;
  flex: unset;
  ${bottomRightOnlyClipPath}
  overflow: visible!important;
  :after {
    overflow: visible !important;
    ${bottomRightOnlyClipPath}
  }
  .row {
    padding: 16px;
  }
  .first {
    border-bottom: 1px solid ${getRgbaValue('#fff', 0.2)};
  }
  span.label {
    font-weight: 700;
  }
  span.amount,
  span.next-level {
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.48px;
  }
  span.next-level {
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-weight: 700;
  }
  .tip {
    z-index: 1000;
  }

  @media screen and (max-width: 1000px) {
    max-width: 100%;

    height: auto;
    min-height: auto;
    max-height: none;
  }
`

export const VaultsAndTokensContainer = styled(Box)`
  // align-items: flex-end;
`
